<template lang="html">
  <div class="">
      <div class="searchclass margin-bot-22">
          <div class="permission-alert-msg" v-show="!ifTeamleaderAnchorPermission">
            You have only view permission.
          </div>
          <div class="block-width-no-use" :disabled="!ifTeamleaderAnchorPermission">
            <search-dropdown v-if="!showEmpDetails"
                placeholder="Search Employee"
                :employeeData="employeeData"
                :clearRequired="true"
                @getList="searchEmployeesByName($event)"
                @empselected="(emp)=>selectedEmp(emp)"/>
          </div>
          <!-- <span class="show-filter-text">
               <img class="search-icon" src="@/assets/filter.png" /> Show Filter
           </span> -->

          <selected-employee-card v-if="showEmpDetails"
            :empName="data.first_name"
            :empId="data.code"
            :dates="data.rlopdates"
            :empMail="data.email_id"
            @click="close">
            <template v-slot:rowcontent="slotprops">
            </template>
          </selected-employee-card>
      </div>
          <data-table
            v-if="showEmpDetails"
            :columns="employeeTableColumns"
            :tableData="employeeDocs"
            :showinrow="false"
            :showedit="false"
            :showhistory="false"
            :showdelete="false"
          >
            <template v-slot:rowcontent="slotprops">
              <div>
                <div v-if="slotprops.value.column.key == 'imgSrc'">
                  <img
                    class="document-img"
                    v-if="slotprops.value.column.key == 'imgSrc'"
                    :src="slotprops.value.record[slotprops.value.column.key]"
                    @click="openModal(slotprops.value)"
                    alt
                  />
                  <p class="document-counts">
                    {{ slotprops.value.record["count"] }}
                  </p>
                </div>

                <img
                  class="cross-circle-img"
                  :class="{'add-plus-icon':showimage}"
                  v-if="slotprops.value.column.key == 'imgSrcAction'"
                  :src="slotprops.value.record[slotprops.value.column.key]"
                  @click="onPickFile(slotprops.value)"
                  alt
                />
                <input
                  type="file"
                  style="display: none"
                  ref="fileInput"
                  accept="image/*"
                  @change="onFilePicked"
                />

                <p
                  v-if="
                    (slotprops.value.column.key == 'documentCategory' ||
                      slotprops.value.column.key == 'modifiedDate' ||
                      slotprops.value.column.key == 'modified_by') &&
                      slotprops.value.column.key != 'imgSrc'  &&
                      slotprops.value.column.key != 'imgSrcAction'"
                >
                  {{ slotprops.value.record[slotprops.value.column.key] }}
                </p>

              </div>
            </template>
      </data-table>

      <pop-up-window
        v-if="showUploadDocuments"
        @back="loadDocuments"
        :header="popUpHeaderTitle">
          <template v-slot:content>
            <upload-documents
            :documents="documents"
            @selectedDocument="openFullDocument"
            @back="!openFullDocument && !showUploadDocuments"
            :viewDocument="viewDocument" >
            </upload-documents>
         </template>

      </pop-up-window>

      <pop-up-window
        v-if="showFullDocuments"
        @back="showFullDocuments = !showFullDocuments"
        :header="popUpHeaderFileName">
          <template v-slot:content>
            <full-document-show
            :document="fullDocument"
            @back="showFullDocuments = !showFullDocuments">
            </full-document-show>
         </template>

      </pop-up-window>
      <!-- <pop-up-message
            v-if="showSuccessMsg"
            :popupType="`Success`"
            :message="`${this.uploadDocument.record.documentCategory} Document Uploaded Successfully!`"
            buttonText="OK"
            @back="showSuccessMsg = !showSuccessMsg"
      /> -->
      <pop-up-message
      v-if="showSuccessMsg"
      :popupType="`Success`"
      :message="`${this.uploadDocument.record.documentCategory} Document Uploaded Successfully!`"
      :closable="false"
    >
      <template v-slot:bottomContent>
        <div class="popup-btn-group">
          <button class="btn-popup-secondary" type="button" @click="cancelEvent()">OK</button>
        </div>
      </template>
    </pop-up-message>
  </div>
</template>
<script>
import SearchDropdown from "@/components/TlSearchDropdown.vue";
import selectedEmployeeCard from "@/components/dashboard/selectedEmployeeCard.vue";
import UploadDocuments from "./uploadDocument.vue";
import FullDocumentShow from "./fullDocumentShow.vue";
import { mapActions, mapGetters, mapState } from "vuex";
import { get_axios_file_instance, api_variables } from "@/apis/variables.js";
var axios_instance = get_axios_file_instance(api_variables.SERVICE_UPLOAD_LOGO);

export default {
  name: "ManageEmployeeDocuments",
  components: {
    SearchDropdown,
    selectedEmployeeCard,
    UploadDocuments,
    FullDocumentShow,
  },
  props: {
    showdocumentupload: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      showEmpDetails: false,
      data: {},
      count: 0,
      showPopup: false,
      showUploadDocuments: false,
      showFullDocuments: false,
      showimage: false,
      popUpHeaderTitle: "",
      popUpHeaderFileName: "",
      employeeData: [],
      emp_id: null,
      selectedIndex: 0,
      showSuccessMsg: false,
      fullDocument: null,
      uploadDocument: null,
      viewDocument: null,
      le:null,
      employeeTableColumns: [
        {
          label: "Document Category",
          key: "documentCategory",
        },
        {
          label: "Modified Date",
          key: "modifiedDate",
        },
        {
          label: "Modified By",
          key: "modified_by",
        },
        {
          label: "Documents",
          key: "imgSrc",
        },
        {
          label: "",
          key: "imgSrcAction",
        },
      ],
      employeeDocs: [],
      companyValue: false,
      role: ""
    };
  },
  mounted() {
    //console.log("New component mounted.");
    this.showSuccessMsg = false;
    this.getOrgLeIdList();
  },

  activated() {
    this.toast = false;
    this.errmsg = "";
    // this.getDocments();
    this.showSuccessMsg = false;
    this.le=this.le_id();
    this.getOrgLeIdList();
  },

  computed: {
    ...mapState({
      globalEmployeeList: (state) =>
        state.globalapi.globalemployees.entityWiseData,
    }),
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID",
    }),
    le_id() {
      //console.log("inside the le_id")
      if (this.$route.params.entity_index) {
        return this.getleid(this.$route.params.entity_index);
      }
      return this.getleid(0);
    },
    requestParams() {
      return {
        le_id: this.le_id,
      };
    },
    ...mapState("onboard/organization", {
      orgId: state => state.id
    }),
    ifTeamleaderAnchorPermission() {
      if(this.role === 'TEAMLEADER' || this.role === 'ANCHOR' || this.role === 'ADMIN') {
        if(this.companyValue) {
          return true;
        } else {
          return false;
        }
      } 
      // else {
      //   return true; 
      // }
    }
  },

  methods: {
    ...mapActions({
      fetchEmployeeByLeAndName: "globalapi/globalemployees/fetchByLeAndName",
      fetchEmployeeDocumentsByEmployeeId:
        "dashboard/organisation/employeeDocument/fetchEmployeeByID",
      uploadEmployeeDocuments: "dashboard/organisation/employeeDocument/create",
    }),

    async searchEmployeesByName(val) {
      try {
        let res = await this.fetchEmployeeByLeAndName({
          le_id: this.le_id,
          key: val,
        });
        this.employeeData = res.data.payload;
        ////console.log("resss",res.data.payload[0].id);
        this.emp_id = res.data.payload[0].id;
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    async selectedEmp(emp) {
      try {
        this.employeeDocs = [];
        ////console.log("empObj", emp);
        this.data = emp;
        // //console.log("inside selected employe",emp)
        this.emp_id = emp.id;
        let res = await this.fetchEmployeeDocumentsByEmployeeId({
          data: { employee_id: emp.id },
        });
        this.loadEmployeeDocuments(res);
        this.showEmpDetails = true;
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    loadEmployeeDocuments(res) {
      let documentList = [];
      if (res.data.payload.education.length > 0) {
        res.data.payload.education.forEach((document) => {
          documentList.push({
            id: document.id,
            location: document.location,
            name: document.name,
            legal_entity_id: this.le_id,
            documents: {
              document_category_id:
                res.data.payload.education[0].document_category_id,
            },
            employee_id: this.emp_id,
          });
        });

        this.employeeDocs.push({
          documentCategory: res.data.payload.education[0].document_category,
          modifiedDate: this.formatDate(
            res.data.payload.education[0].updated_at
          ),
          modified_by: res.data.payload.education[0].modified_by,
          imgSrc: require("@/assets/invalid-name.svg"),
          count: res.data.payload.education.length,
          imgSrcAction: require("@/assets/circle-cross.svg"),
          documents: documentList,
          document_category_id:
            res.data.payload.education[0].document_category_id,
        });
      } else {
        this.employeeDocs.push({
          documentCategory: "Educational",
          modifiedDate: null,
          modified_by: null,
          imgSrc: require("@/assets/invalid-name.svg"),
          count: 0,
          imgSrcAction: require("@/assets/circle-cross.svg"),
          documents: [],
          document_category_id: "f646be68-00a0-48aa-ae02-71c102668221",
        });
      }

      if (res.data.payload.professional.length > 0) {
        documentList = [];
        res.data.payload.professional.forEach((document) => {
          documentList.push({
            id: document.id,
            location: document.location,
            name: document.name,
            legal_entity_id: this.le_id,
            documents: {
              document_category_id:
                res.data.payload.professional[0].document_category_id,
            },
            employee_id: this.emp_id,
          });
        });

        this.employeeDocs.push({
          documentCategory: res.data.payload.professional[0].document_category,
          modifiedDate: this.formatDate(
            res.data.payload.professional[0].updated_at
          ),
          modified_by: res.data.payload.professional[0].modified_by,
          imgSrc: require("@/assets/invalid-name.svg"),
          count: res.data.payload.professional.length,
          imgSrcAction: require("@/assets/circle-cross.svg"),
          documents: documentList,
          document_category_id:
            res.data.payload.professional[0].document_category_id,
        });
      } else {
        this.employeeDocs.push({
          documentCategory: "Professional",
          modifiedDate: null,
          modified_by: null,
          imgSrc: require("@/assets/invalid-name.svg"),
          count: 0,
          imgSrcAction: require("@/assets/circle-cross.svg"),
          documents: [],
          document_category_id: "f646be68-00a0-48aa-ae02-71c102668222",
        });
      }

      if (res.data.payload.personal.length > 0) {
        documentList = [];
        res.data.payload.personal.forEach((document) => {
          documentList.push({
            id: document.id,
            location: document.location,
            name: document.name,
            legal_entity_id: this.le_id,
            documents: {
              document_category_id:
                res.data.payload.personal[0].document_category_id,
            },
            employee_id: this.emp_id,
          });
        });

        this.employeeDocs.push({
          documentCategory: res.data.payload.personal[0].document_category,
          modifiedDate: this.formatDate(
            res.data.payload.personal[0].updated_at
          ),
          modified_by: res.data.payload.personal[0].modified_by,
          imgSrc: require("@/assets/invalid-name.svg"),
          count: res.data.payload.personal.length,
          imgSrcAction: require("@/assets/circle-cross.svg"),
          documents: documentList,
          document_category_id:
            res.data.payload.personal[0].document_category_id,
        });
      } else {
        this.employeeDocs.push({
          documentCategory: "Personal",
          modifiedDate: null,
          modified_by: null,
          imgSrc: require("@/assets/invalid-name.svg"),
          count: 0,
          imgSrcAction: require("@/assets/circle-cross.svg"),
          documents: [],
          document_category_id: "f646be68-00a0-48aa-ae02-71c102668220",
        });
      }

      //console.log(this.employeeDocs);
    },

    close() {
      this.showEmpDetails = false;
    },

    openModal(category) {
      //console.log("category", category);
      this.popUpHeaderTitle = category.record.documentCategory;
      this.documents = category.record.documents;
      // this.documents.emp_id = this.emp_id;
      this.showUploadDocuments = true;
      this.showFullDocuments = false;
      this.viewDocument = {
        document: category.record,
        employee_id: this.emp_id,
        legal_entity_id: this.le_id,
      };
    },

    formatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [day, month, year].join("/");
    },

    openFullDocument(document) {
      //console.log("Open full document", document);
      this.popUpHeaderFileName = document.name;
      this.fullDocument = document;
      this.fullDocument.emp_id = this.emp_id;
      this.showUploadDocuments = false;
      this.showFullDocuments = true;
    },

    onPickFile(document) {
      this.uploadDocument = document;
      this.uploadDocument.employee_id = this.emp_id;
      this.uploadDocument.legal_entity_id = this.le_id;
      this.showimage = !this.showimage;
      this.$refs.fileInput.click();
    },

    async onFilePicked(event) {
      const files = event.target.files;
      //let filename = files[0].name
      let formData = new FormData();
      formData.append("file", files[0]);
      let res = await axios_instance.post("", formData);
      if (res.data.status) {
        let fileLocation = res.data.location;
        let data = {
          id: this.emp_id,
          legal_entity_id: this.le_id,
          documents: {
            document_category_id: this.uploadDocument.record
              .document_category_id,
            document_category: this.uploadDocument.record.documentCategory,
            location: fileLocation,
            modified_by: this.emp_id,
            name: files[0].name.split(".")[0],
          },
        };
        let fileRes = await this.uploadEmployeeDocuments(data);
        //console.log("Filessss ", fileRes);
        if (fileRes.data.status) {
          let fileIndex = this.employeeDocs.findIndex(
            (i) =>
              i.documentCategory === this.uploadDocument.record.documentCategory
          );
          if (fileIndex !== -1) {
            this.employeeDocs[fileIndex]["documents"].push({
              id: this.emp_id,
              location: fileLocation,
              name: files[0].name.split(".")[0],
              legal_entity_id: this.le_id,
              documents: {
                document_category_id: this.uploadDocument.document_category_id,
              },
              employee_id: this.emp_id,
            });
            this.employeeDocs[fileIndex]["count"] = this.employeeDocs[
              fileIndex
            ]["documents"].length;
            this.employeeDocs[fileIndex]["modifiedDate"] = this.formatDate(new Date());
            this.employeeDocs[fileIndex]["modified_by"] = this.data.first_name;
            // this.uploadDocument = null;
            this.showSuccessMsg = true;
          }
        }
      }
    },

    async loadDocuments() {
      let res = await this.fetchEmployeeDocumentsByEmployeeId({
        data: { employee_id: this.emp_id },
      });
      this.employeeDocs = [];
      this.loadEmployeeDocuments(res);
      this.showUploadDocuments = !this.showUploadDocuments;
    },

    cancelEvent() {
      this.showSuccessMsg = false;
    },
    // goToVPFPage() {
    //   this.$router.push({
    //     path: `/dashboard/${this.$route.params.entity_index}/organisation/utilities/voluntaryPf`,
    //   });
    // },

    ...mapActions({
        getOrgLeList: "onboard/organization/getOrgLeIdList",
    }),

    async getOrgLeIdList() {
      const org = this.orgId;
      const le = this.le_id;
      //console.log("Org:",org);
      //console.log("Le ID",le);
      let bodyParams = {};
      let  data = await this.getOrgLeList({
        data: {
            ...bodyParams
        }
      });
      //{org_id:this.orgId, le_id:this.le_id}
      this.role = data.data.user.userRole;
      this.companyValue = data.data.user.permissions.company ? true : false;
      //console.log("PL-3406",data);
    }
  },
};
</script>

<style lang="scss" scoped>
.margin-bot-22 {
  margin-bottom: 22px;
}
.block-width {
  display: inline-table;
}
.show-filter-text {
  margin-left: 5%;
  font-weight: bold;
  color: #37c6c0;
}
.document-img {
  width: 24px;
  height: 18px;
  cursor: pointer;
}

.cross-circle-img {
  width: 24px;
  height: 18px;
  cursor: pointer;
}

.add-plus-icon {
  opacity: 0.5;
  // display: none;
  &:hover {
    // display: block;
    opacity: 0.7;
    cursor: pointer;
  }
}

.document-counts {
  display: inline-block;
  font-weight: bold;
  margin: 0 0 0 8px;
  font-size: 14px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #34c0be;
}

tr.record-row:hover {
  background: #ebf9f8;
}

.permission-alert-msg {
  background-color: #f8d7da;
  padding: 1rem 1rem;
  margin-top: 1rem;
  margin-bottom: 1rem;
  font-weight: 600;
  color: #842029;
  border: 1px solid transparent;
  border-radius: .25rem;
  border-color: #f5c2c7;
}
</style>
